<iframe
    [src]="iFrameUrl | sanitize: securityContext.RESOURCE_URL"
    class="border-0 h-full w-full"></iframe>
